import React from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import './UserProfile.css';

const UserProfile = () => {
  const { user, logout, isLoading, error, hasRole } = useAuth();
  const history = useHistory();

  const handleLogout = async () => {
    await logout();
    history.push('/login');
  };

  if (isLoading) {
    return (
      <div className="user-profile loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-profile error">
        <p>Error loading user profile</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="user-profile">
      <div className="user-info">
        <div className="user-avatar">
          {user.name ? user.name.charAt(0).toUpperCase() : '?'}
        </div>
        <div className="user-details">
          <h3>{user.name}</h3>
          <p>{user.email}</p>
          <div className="user-roles">
            {user.groups?.map((role) => (
              <span key={role} className="role-badge">
                {role}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="profile-actions">
        {hasRole('Administrator') && (
          <button
            className="settings-button"
            onClick={() => history.push('/admin')}
          >
            Settings
          </button>
        )}
        <button className="logout-button" onClick={handleLogout}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default UserProfile;
